
import { useRef } from "react";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Colors } from "../../styles/theme";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import validLookup from "../../utils/validLookup";
import { jelloHorizontal, rollInLeft } from "../../animation";

function PaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#confirmation-dialog-title"
        >
            <Paper id="confirmation-dialog-title" ref={nodeRef} {...props} />
        </Draggable>
    );
}

export default function ConfirmationDialog({
    open,
    onClose,
    message,
    title,
    listener,
    label
}) {

    const handleCancel = () => {
        listener && listener(validLookup.confirmationDialogAction.cancel);
        onClose();
    }

    const handleOk = () => {
        listener && listener(validLookup.confirmationDialogAction.ok);
    }

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth={'xs'} hideBackdrop  PaperComponent={PaperComponent} sx={{
            animation: `${jelloHorizontal} 0.9s ease both`,
        }}>
            <DialogTitle sx={{ background: Colors.primary, mb: 0, color: Colors.white, cursor: 'move' }}
                aria-labelledby="choose-time-dialog-title">
                <Box display={"flex"} alignItems="center" justifyContent={'space-between'} gap={1}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <WarningAmberIcon fontSize="small" />
                        <span>{title || "Confirmation"}</span>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Typography sx={{paddingTop: 2, fontSize: '1.875rem', fontWeight: '300', color: Colors.dim_grey}}>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    {label.negative}
                </Button>
                <Button onClick={handleOk} variant="contained">
                    {label.positive}
                </Button>
            </DialogActions>
        </Dialog>
    )
}